import React, { Fragment, useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import 'react-toastify/dist/ReactToastify.css';
import { Link, useNavigate, useLocation } from "react-router-dom";
import Spinner from "../FieldComponets/Spinner";
import { ErrorMessage } from '@hookform/error-message';
import { useDispatch, useSelector } from 'react-redux';
import ToastDefault from "../FieldComponets/Toast";
import PageLayout from "../Layouts/PageLayout";
// import { CategoryAddAction , CategoryGetAction } from "../../Redux/Action/Category";
import { ServiceAddAction, ServiceCategoryAddAction, ServiceDtailsAction } from "../../Redux/Action/ServiceAction";
import { decodeID, getLastURL } from "../../utils/Helper";
import { getDate } from "../../utils/Helper";




function ServiceAdd() {
  const dispatch = useDispatch<any>();
  const navigate = useNavigate()
  const log_in = useSelector((state: any) => state.ServiceDetailsState)
  const servicedata = useSelector((state: any) => state.ServiceDetailsState?.data?.data?.detail)
  const location = useLocation();
  const editId = getLastURL(location);
  const [loading  , setLoading] = useState(false)
  const [completed , setCompleted] = useState(0)
  const [pending , setPending] = useState(0)
  const [noShow , setNoShow] = useState(0)
  const [cancel , setCancel] = useState(0)
  const [cancelnycustomer , setCancelnycustomer ] = useState(0)


  useEffect(() => {
    setLoading(true)
    setCancel(0) 
    setCompleted(0)
    setNoShow(0)
    setPending(0)
    setCancelnycustomer(0)
    var params = {
      detail_id: decodeID(editId)
    };
    dispatch(ServiceDtailsAction(params))
    setTimeout(() => {
      setLoading(false)
    }, 400);
  }, [])

  useEffect(()=>{
  let completedbooking  = servicedata?.book_services && servicedata?.book_services.filter((res:any)=>res.status == "1")
  let pendingbooking  = servicedata?.book_services && servicedata?.book_services.filter((res:any)=>res.status == "0")
  let noShowbooking  = servicedata?.book_services && servicedata?.book_services.filter((res:any)=>res.status == "3")
  let canclebooking  = servicedata?.book_services && servicedata?.book_services.filter((res:any)=>res.status == "2" && res.changed_by == "2")
  let cancleCustomerbooking  = servicedata?.book_services && servicedata?.book_services.filter((res:any)=>res.status == "2" && res.changed_by == '1')


  setCancel(canclebooking?.length) 
  setCompleted(completedbooking?.length)
  setNoShow(noShowbooking?.length)
  setPending(pendingbooking?.length)
  setCancelnycustomer(cancleCustomerbooking?.length)
  },[log_in.status])
  const handleBack = () => {
    navigate('/service')
    setCancel(0) 
    setCompleted(0)
    setNoShow(0)
    setPending(0)
    setCancelnycustomer(0)
  }
  return (
    <Fragment>
      { loading || log_in?.loading ? <Spinner /> : ""}
      <PageLayout
        title="Service Details"
        breadcrumbs={{
          secLast: { 'link': '/service', 'name': 'Service List' },
        }}
        buttons={[
          { url: '/class-add', className: 'btn btn-primary', text: '+ Add Sponsors', show: false }, // This button will be shown
        ]}
      >
        <div className="card">
          <div className="card-body">
            <div className="row gy-4">

              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"> Service Name :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.name ? servicedata?.name : '--'}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label">Service price :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.price ? servicedata.price : '--'}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label">Service Duration :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.duration ? servicedata?.duration : '--'}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"> Service Description :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.description ? servicedata?.description : '--'}</span>
                  </div>
                </div>
              </div>
                <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label"> Service Category :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.category_details?.name ? servicedata?.category_details?.name : '--'}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label">Status :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.status == "1" ? "Active" : "Inactive"}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label">Salon Name :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.salon_details?.salon_name}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label">Salon Phone Number :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.salon_details?.phone_country_code.split('+').length > 1 ? servicedata?.salon_details?.phone_country_code : `${servicedata?.salon_details?.phone_country_code} +`  } {servicedata?.salon_details?.phone_number}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label">Salon Email :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.salon_details?.email ? servicedata?.salon_details?.email : 'no email'}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label">Create Date :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.created_at ? getDate(servicedata?.created_at) : '--'}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label">Update Date :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.created_at ? getDate(servicedata?.updated_at) : '--'}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label">Total Booked Service :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{servicedata?.book_services?.length > 0 ? servicedata?.book_services?.length : 0}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label">Total Completed Service :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{completed}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label">Total Cancelled Service By Customer :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{cancelnycustomer}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label">Total Cancelled Service By Salon :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{cancel}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label">Total Pending Service :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{pending}</span>
                  </div>
                </div>
              </div>
              <div className="col-md-6">
                <div className="row">
                  <div className="col-md-3">
                    <label htmlFor="username" className="form-label">Total No Shown Up Service :</label>
                  </div>
                  <div className="col-md-9">
                    <span>{noShow}</span>
                  </div>
                </div>
              </div>
              <div className="col-12">
                <button type="submit" className="btn btn-primary waves-effect waves-light" onClick={() => handleBack()} >BACK</button>
              </div>
            </div>
          </div>
        </div>
        <ToastDefault />
      </PageLayout>
    </Fragment>
  );
}

export default ServiceAdd;